import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AlertComponent } from './alert/alert.component';
import { FeedbackBlockComponent } from './feedback-block/feedback-block.component';
import { InfoBannerComponent } from './info-banner/info-banner.component';

@NgModule({
  imports: [
    CommonModule,
  ],
  declarations: [
    AlertComponent,
    FeedbackBlockComponent,
    InfoBannerComponent,
  ],
  exports: [
    AlertComponent,
    FeedbackBlockComponent,
    InfoBannerComponent,
  ],
})
export class FeedbackComponentsModule {}
